import type { CSSProperties } from "react";

export function getStaggerStyle(index: number, reducedMotion: boolean): CSSProperties {
  if (reducedMotion) {
    return {};
  }

  return {
    animationDelay: `${index * 90}ms`
  };
}

export function getMotionClass(reducedMotion: boolean, animatedClass: string): string {
  return reducedMotion ? "motion-static" : animatedClass;
}
